/* ═══════════════════════════════════════════════════════════
   DESIGN TOKENS & SHARED STYLES
   ═══════════════════════════════════════════════════════════ */

export const T = {
  bg: "#09090b", bg2: "#0f0f12", bg3: "#141418", bgEl: "#1a1a1f",
  border: "rgba(255,255,255,.055)", borderH: "rgba(255,255,255,.12)",
  text: "#f4f4f5", text2: "#a1a1aa", text3: "#8c8c96",
  green: "#22c55e", red: "#ef4444", blue: "#3b82f6", purple: "#8b5cf6", yellow: "#eab308",
  radius: 12, radiusLg: 16, radiusSm: 8,
  font: "'DM Sans',-apple-system,BlinkMacSystemFont,sans-serif",
};

export const cardStyle = { background: T.bg2, border: `1px solid ${T.border}`, borderRadius: T.radiusLg, transition: "border-color .3s, box-shadow .3s", boxShadow: "0 2px 8px rgba(0,0,0,.2)" };

export const inputStyle = {
  width: "100%", padding: "12px 16px", borderRadius: T.radius, border: `1px solid ${T.border}`,
  background: T.bg, color: T.text, fontSize: 14, fontFamily: T.font, outline: "none", transition: "border-color .3s",
};

export const btnPrimary = {
  width: "100%", padding: "13px 24px", borderRadius: T.radius, border: "none",
  background: "#fff", color: T.bg, fontSize: 14, fontWeight: 700, fontFamily: T.font,
  cursor: "pointer", transition: "all .3s", display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
};

export const btnGhost = { ...btnPrimary, background: "transparent", border: `1px solid ${T.border}`, color: T.text };

export const tagStyle = (color = T.text2) => ({
  display: "inline-flex", padding: "4px 12px", borderRadius: 100, fontSize: 11, fontWeight: 600,
  background: `${color}15`, color, border: `1px solid ${color}25`,
});

/* ── A1 / A6: Dark glass depth system ──────────────────── */
export const DEPTH = {
  base:     { background: "#06060a" },
  elevated: { background: "#0f0f14", boxShadow: "0 2px 12px rgba(0,0,0,.3)" },
  floating: { background: "#1a1a22", boxShadow: "0 8px 32px rgba(0,0,0,.5), 0 0 0 1px rgba(255,255,255,.06)" },
};

export const GLASS_PANEL = {
  background: "linear-gradient(145deg, rgba(255,255,255,.05), rgba(255,255,255,.015))",
  border: "1px solid rgba(255,255,255,.08)",
  borderRadius: 20,
  backdropFilter: "blur(16px) saturate(1.2)",
  boxShadow: "0 8px 32px rgba(0,0,0,.4), inset 0 1px 0 rgba(255,255,255,.08), inset 0 -1px 0 rgba(255,255,255,.02)",
};

export const GLASS_CARD = { ...GLASS_PANEL, borderRadius: 16, backdropFilter: "blur(12px)" };

export const GLASS_INPUT = {
  background: "rgba(255,255,255,.04)",
  border: "1px solid rgba(255,255,255,.08)",
  backdropFilter: "blur(8px)",
};

export const gradientMesh = (accent = "#3b82f6") => ({
  background: `radial-gradient(ellipse at 20% 20%, ${accent}08 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, #8b5cf608 0%, transparent 50%), radial-gradient(ellipse at 50% 50%, #06060a 0%, #06060a 100%)`,
});
